import { render } from "./myHeader.vue?vue&type=template&id=5f849932&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"

import "./myHeader.vue?vue&type=style&index=0&id=5f849932&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f849932"]])

export default __exports__